import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  mongodbReboot: {
    environment: [],
    scheduledTime: null,
    scheduleEndTimeHours: '6',
    additionalOperations: '',
    notificationTime: null,
    sendPostNotification: true,
    sendInternalNotification: true,
    sendStartNotificationBefore: true,
    notificationBeforeTime: '10',
    isFormValid: false,
    scheduleRebootDialogOpen: false,
    healthChecks: [],
    groupedHealthChecks: {},
    loading: false
  }
};

export const turboSlice = createSlice({
  name: 'turbo',
  initialState,
  reducers: {
    // MongoDB Reboot actions
    setMongoDBRebootEnvironment: (state, action) => {
      state.mongodbReboot.environment = action.payload;
      state.mongodbReboot.isFormValid = Boolean(
        state.mongodbReboot.environment.length > 0 &&
          state.mongodbReboot.scheduledTime
      );
    },
    setMongoDBRebootScheduledTime: (state, action) => {
      state.mongodbReboot.scheduledTime = action.payload;
      state.mongodbReboot.isFormValid = Boolean(
        state.mongodbReboot.environment.length > 0 &&
          state.mongodbReboot.scheduledTime
      );
    },
    setMongoDBRebootScheduleEndTimeHours: (state, action) => {
      state.mongodbReboot.scheduleEndTimeHours = action.payload;
    },
    setMongoDBRebootAdditionalOperations: (state, action) => {
      state.mongodbReboot.additionalOperations = action.payload;
    },
    setMongoDBRebootNotificationTime: (state, action) => {
      state.mongodbReboot.notificationTime = action.payload;
    },
    setMongoDBRebootSendPostNotification: (state, action) => {
      state.mongodbReboot.sendPostNotification = action.payload;
    },
    setMongoDBRebootSendInternalNotification: (state, action) => {
      state.mongodbReboot.sendInternalNotification = action.payload;
    },
    setMongoDBRebootSendStartNotificationBefore: (state, action) => {
      state.mongodbReboot.sendStartNotificationBefore = action.payload;
    },
    setMongoDBRebootNotificationBeforeTime: (state, action) => {
      state.mongodbReboot.notificationBeforeTime = action.payload;
    },
    setMongoDBRebootDialogOpen: (state, action) => {
      state.mongodbReboot.scheduleRebootDialogOpen = action.payload;
    },
    resetMongoDBRebootForm: (state) => {
      // Save the current scheduleRebootDialogOpen state
      const currentDialogOpen = state.mongodbReboot.scheduleRebootDialogOpen;

      // Reset all form fields but keep scheduleRebootDialogOpen state
      state.mongodbReboot = {
        ...initialState.mongodbReboot,
        scheduleRebootDialogOpen: currentDialogOpen
      };
    },
    // Health Checks actions
    setHealthChecksLoading: (state, action) => {
      state.mongodbReboot.loading = action.payload;
    },
    setHealthChecks: (state, action) => {
      state.mongodbReboot.healthChecks = action.payload;

      // Group health checks by environmentId
      const grouped = {};
      action.payload.forEach((check) => {
        if (!grouped[check.environmentId]) {
          grouped[check.environmentId] = [];
        }
        grouped[check.environmentId].push(check);
      });

      state.mongodbReboot.groupedHealthChecks = grouped;
    }
  }
});

export const {
  // MongoDB Reboot actions
  setMongoDBRebootEnvironment,
  setMongoDBRebootScheduledTime,
  setMongoDBRebootScheduleEndTimeHours,
  setMongoDBRebootAdditionalOperations,
  setMongoDBRebootNotificationTime,
  setMongoDBRebootSendStartNotification,
  setMongoDBRebootSendPostNotification,
  setMongoDBRebootSendInternalNotification,
  setMongoDBRebootSendStartNotificationBefore,
  setMongoDBRebootNotificationBeforeTime,
  setMongoDBRebootDialogOpen,
  resetMongoDBRebootForm,

  // Health Checks actions
  setHealthChecksLoading,
  setHealthChecks
} = turboSlice.actions;

export default turboSlice.reducer;
